import { make } from "vuex-pathify";
import { getAPI, getDownloadAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
  loading: false,
};

// getters
const getters = {};

// actions
const actions = {

  retrieveStockHistory({ commit }, params) {
    commit("SET_LOADING", true);
    return getAPI("stockHistory/retrieveStockHistory", params).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  exportExcelStockHistory({ commit }, params) {
    commit("SET_LOADING", true);
    return getDownloadAPI("stockHistory/exportExcelStockHistory", params).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

};

// mutations
const mutations = {
  ...make.mutations(state),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

